import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getSirenaQuotes(leadId) {
  const response = await axios.get(`${REACT_APP_API}/sirena/quotes/${leadId}`)
  return response
}